const required = (v?: string, name?: string): string => {
  if (!v) throw new Error(`Missing environment variable ${name}`);
  return v;
};
const optional = (v?: string): string | undefined => {
  if (v === undefined || v === null || v === "") return undefined;
  return v;
};

export const IS_PRODUCTION =
  process.env.NEXT_PUBLIC_VERCEL_ENV === "production";

export const IS_DEVELOPMENT =
  process.env.NEXT_PUBLIC_VERCEL_ENV === "development";

export const DISCOUNTS_API = required(
  process.env.NEXT_PUBLIC_DISCOUNTS_API,
  "NEXT_PUBLIC_DISCOUNTS_API",
);
export const EXTERNAL_ORIGIN_API = required(
  process.env.NEXT_PUBLIC_EXTERNAL_ORIGIN_API,
  "NEXT_PUBLIC_EXTERNAL_ORIGIN_API",
);
export const FULFILLMENT_API = required(
  process.env.NEXT_PUBLIC_FULFILLMENT_API,
  "NEXT_PUBLIC_FULFILLMENT_API",
);
export const PAYMENTS_API = required(
  process.env.NEXT_PUBLIC_PAYMENTS_API,
  "NEXT_PUBLIC_PAYMENTS_API",
);
export const PAYWALL_API = required(
  process.env.NEXT_PUBLIC_PAYWALL_API,
  "NEXT_PUBLIC_PAYWALL_API",
);
export const PROFILE_API = required(
  process.env.NEXT_PUBLIC_PROFILE_API,
  "NEXT_PUBLIC_PROFILE_API",
);
export const STATS_API = required(
  process.env.NEXT_PUBLIC_STATS_API_V2,
  "NEXT_PUBLIC_STATS_API_V2",
);
export const VAULT_API = required(
  process.env.NEXT_PUBLIC_VAULT_API,
  "NEXT_PUBLIC_VAULT_API",
);
export const PODCAST_API = required(
  process.env.NEXT_PUBLIC_PODCAST_API_URL,
  "NEXT_PUBLIC_PODCAST_API_URL",
);
export const CHECKOUT_API = required(
  process.env.NEXT_PUBLIC_CHECKOUT_API,
  "NEXT_PUBLIC_CHECKOUT_API",
);
export const DISCOVERY_API = required(
  process.env.NEXT_PUBLIC_DISCOVERY_API,
  "NEXT_PUBLIC_DISCOVERY_API",
);
export const CATALOG_API = required(
  process.env.NEXT_PUBLIC_CATALOG_API,
  "NEXT_PUBLIC_CATALOG_API",
);
export const API_PROXY = required(
  process.env.NEXT_PUBLIC_API_PROXY,
  "NEXT_PUBLIC_API_PROXY",
);
export const SHORTLINK_API = required(
  process.env.NEXT_PUBLIC_SHORTLINK_API_URL,
  "NEXT_PUBLIC_SHORTLINK_API_URL",
);
export const POSTAL_API = required(
  process.env.NEXT_PUBLIC_POSTAL_API,
  "NEXT_PUBLIC_POSTAL_API",
);
export const CHECKOUT_URL = required(
  process.env.NEXT_PUBLIC_CHECKOUT_URL,
  "NEXT_PUBLIC_CHECKOUT_URL",
);
export const ACCOUNT_URL = required(
  process.env.NEXT_PUBLIC_ACCOUNT_URL,
  "NEXT_PUBLIC_ACCOUNT_URL",
);
export const CONSUME_URL = required(
  process.env.NEXT_PUBLIC_CONSUME_URL,
  "NEXT_PUBLIC_CONSUME_URL",
);
export const AG_GRID_ENTERPRISE_LICENSE_KEY = optional(
  process.env.NEXT_PUBLIC_AG_GRID_ENTERPRISE_LICENSE_KEY,
);
export const N8N_WEBHOOK_URL = optional(
  process.env.NEXT_PUBLIC_N8N_WEBHOOK_URL,
);

export const getIntegrationsApiUrl = () =>
  PROFILE_API.replace("/profile", "/webhooks/integrations");
